import script from "./RiskArgeement.vue?vue&type=script&lang=ts&setup=true"
export * from "./RiskArgeement.vue?vue&type=script&lang=ts&setup=true"

import "./RiskArgeement.vue?vue&type=style&index=0&id=1ac5ccb7&lang=scss"

const __exports__ = script;

export default __exports__